import { Component, OnInit } from '@angular/core';
import { HealthServiceService } from './service/health.service.service';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.css']
})
export class HealthComponent implements OnInit {
  constructor(private readonly healthService: HealthServiceService) {
  }
  response: any;
  isError = false;
  ngOnInit(): void {
    this.healthService.connectBackEnd().subscribe({
      next: (data) => this.response = data,
      error: (err) => {
        this.isError = true;
        this.response = `${err.error.ads} and ${err.error.database}`; 
        console.log(err);
      }
    });     
  }

}
